export default "__VITE_ASSET__CI_8OVTo__"